import { Pipe, PipeTransform } from '@angular/core';
import { Train } from '../models/train';

@Pipe({
  name: 'getTrain'
})
export class GetTrainPipe implements PipeTransform {

  transform(trainId: number, trains: Train[]): Train | undefined {
    return (trainId && trains) ? trains.find(train => train.relativeId === trainId) : undefined;
  }

}
